﻿import { ApiOptions } from "../models/ApiOptions";

const typeOfUndefined = typeof undefined;

export const sendApiCall = (options: ApiOptions) =>
{
    let endpoint;
    let rawUrl = location.pathname;
    let qsDictionary: Array<any> | any = {};
    let formDictionary: Array<any> | any = {};
    let callback = function (data: any, textStatus: any, jqXHR: any) { };
    let beforeSend: (param: boolean | JQueryXHR) => void = function (param) { };
    let callType = "POST";
    let errorCallback = function (jqXHR, exception)
    {
        console.error(jqXHR);
        console.error(exception);
    };

    if (options.endpoint)
        endpoint = options.endpoint;

    if (options.rawUrl)
        rawUrl = options.rawUrl;

    if (options.qsDictionary)
        qsDictionary = options.qsDictionary;

    if (options.formDictionary)
        formDictionary = options.formDictionary;

    if (options.callback)
        callback = options.callback;

    if (options.beforeSend)
        beforeSend = options.beforeSend;

    if (options.errorCallback)
        errorCallback = options.errorCallback;

    if (options.callType)
        callType = options.callType;

    var qsPostData = {};

    if (Array.isArray(qsDictionary))
    {
        qsDictionary.forEach(function (item)
        {
            var keys = Object.keys(item);
            keys.forEach(function (keyItem)
            {
                if (typeof qsPostData[keyItem] !== typeOfUndefined)
                    qsPostData[keyItem] += "," + item[keyItem];
                else
                    qsPostData[keyItem] = item[keyItem];
            });
        });
    }

    var disableCacheGet = "";

    if (!qsPostData["nocacheget"])
    {
        var searchParams = new URLSearchParams(window.location.search);

        if (searchParams.size > 0 &&
            searchParams.get("nocacheget") === "1"
        )
            disableCacheGet = "?nocacheget=1";
    }

    var formPostData = {};
    if (Array.isArray(formDictionary))
    {
        formDictionary.forEach(function (item)
        {
            var keys = Object.keys(item);
            keys.forEach(function (keyItem)
            {
                if (typeof formPostData[keyItem] !== typeOfUndefined)
                    formPostData[keyItem] += "," + item[keyItem];
                else
                    formPostData[keyItem] = item[keyItem];
            });
        });
    }

    var requestDto = null;

    if (options.customDto)
        requestDto = options.customDto;
    else
    {
        requestDto = {
            "SiteID": shopConfig().currentSiteID,
            "ShopMode": options.shopMode ?? "",
            "BaseUrl": rawUrl,
            "QsDictionary": qsPostData,
            "FormDictionary": formPostData
        };
    }

    var port = "";

    if (window.location.port?.length > 0)
    {
        var portNumber = parseInt(window.location.port);

        if (portNumber > 8000 &&
            portNumber < 8100
        )
            port = ":" + window.location.port;
    }

    const settings: JQueryAjaxSettings = {
        url: shopConfig().api.path + port + endpoint + disableCacheGet,
        beforeSend: (jqXHR, settings) => { beforeSend(jqXHR); },
        type: callType,
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        data: JSON.stringify(requestDto),
        headers: {
            'x-api-version': shopConfig().api.version,
            'site-id': shopConfig().currentSiteID.toString(),
        },
        xhrFields: {
            withCredentials: true
        },
        success: callback,
        error: errorCallback,
    };

    return $.ajax(settings);
}